import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
const PackageStatusChartData = () => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });
  useEffect(() => {
    setChartData({
      series: [52, 14],
      options: {
        chart: {
          type: "donut",
        },
        legend: {
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 580,
            options: {
              chart: {
                width: 200,
                height: 200,
              },
            },
          },
        ],
        labels: ["Expired Packages", "Unexpired packages"],
        colors: ["#042b49", "#38729e"],
        plotOptions: {
          pie: {
            donut: {
              size: "45%",
            },
          },
        },
      },
    });
  }, []);
  return (
    <div className="graph__title">
      {/* <p><b>Words</b></p> */}
      <div id="chart">
        <ReactApexChart
          options={chartData?.options}
          series={chartData?.series}
          type="donut"
          height="300"
        />
      </div>
    </div>
  );
};
export default PackageStatusChartData;
